import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddDocumentUpload from "../../Models/AddCerificates/addCertificates";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import {
  GetCertificate,
  deleteCertificate,
} from "../../apis/api/CertificateApi";
import { useDispatch, useSelector } from "react-redux";
import Lodderr from "../../components/Lodder/Lodder";
import { toast } from "react-toastify";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { motion } from "framer-motion";
import { isImageFile, getDocumentIconDetails } from "../../utils/fileUtils";
import "./Certificates.css";

const Certificates = () => {
  const navigate = useNavigate();
  const [openModel, setCloseModel] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [imgErrors, setImgErrors] = useState({});

  const dispatch = useDispatch();
  const location = useLocation();
  const company_id = location.state?.company_id;
  const CookiesCompany_id = Cookies.get("company_id");
  const isOwnCompany =
    !company_id ||
    String(company_id) === String(CookiesCompany_id || "");

  useEffect(() => {
    if (company_id) {
      dispatch(GetCertificate({ company_id: company_id }));
    } else {
      dispatch(GetCertificate({ company_id: CookiesCompany_id }));
    }
  }, [company_id]);

  const { CertificateData, loading } = useSelector(
    (state) => state.CertificateSlice
  );

  const handleDeleteClick = (doc) => {
    setSelectedDoc(doc);
  };

  const confirmDelete = async () => {
    const response = await dispatch(deleteCertificate({ id: selectedDoc.id }));
    if (response.payload.status === "success") {
      dispatch(GetCertificate({ company_id: CookiesCompany_id }));
      toast.success("Document deleted successfully.");
      setSelectedDoc(null);
    } else {
      toast.error("Error deleting document.");
    }
  };

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "certificate";
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Unable to download file.");
    }
  };

  return (
    <>
      {loading && <Lodderr />}

      <AddDocumentUpload
        show={openModel}
        handleClose={() => setCloseModel(false)}
      />

      <motion.div
        className="ct-wrap"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="ct-hero">
          <div>
            <h1 className="ct-title">Certificates</h1>
            <p className="ct-sub">
              View and manage documents in a clean premium layout.
            </p>
          </div>

          <div className="ct-hero-right">
            <span className="ct-pill">
              <i className="bx bx-certification"></i>{" "}
              {(CertificateData?.result || []).length} files
            </span>
            {isOwnCompany && (
              <button
                className="ct-add"
                onClick={() => setCloseModel(true)}
                type="button"
              >
                <i className="bx bx-plus"></i> Add Certificate
              </button>
            )}
          </div>
        </div>

        {CertificateData?.result && CertificateData.result.length > 0 ? (
          <div className="ct-grid">
            {CertificateData.result.map((cert, index) => {
              const cleanUrl = cert.file_url ? cert.file_url.replace("thumb/", "") : "#";
              const title = cert.title || cert.file_name || "Certificate";
              const date = cert.created_at
                ? new Date(cert.created_at * 1000).toLocaleDateString()
                : "-";
              const isImg = isImageFile(cert);
              const docDetails = getDocumentIconDetails(cert);
              const certKey = cert.id || index;
              const hasImgError = imgErrors[certKey];

              return (
                <motion.article
                  key={certKey}
                  className="ct-card"
                  initial={{ opacity: 0, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    delay: index * 0.03,
                    duration: 0.35,
                    ease: [0.22, 0.68, 0, 1.2],
                  }}
                  whileHover={{ y: -6 }}
                >
                  <div
                    className="ct-thumb"
                    style={!isImg || hasImgError ? { backgroundColor: docDetails.bg } : {}}
                  >
                    {isImg && !hasImgError ? (
                      <img
                        src={cert.file_url}
                        alt={title}
                        loading="lazy"
                        onError={() => {
                          setImgErrors((prev) => ({ ...prev, [certKey]: true }));
                        }}
                      />
                    ) : (
                      <div className="ct-doc-preview">
                        <i
                          className={docDetails.icon}
                          style={{ color: docDetails.color }}
                        ></i>
                        <span
                          className="ct-doc-label"
                          style={{
                            color: docDetails.color,
                            borderColor: `${docDetails.color}33`,
                          }}
                        >
                          {docDetails.label}
                        </span>
                      </div>
                    )}
                    <span className="ct-date">
                      <i className="bx bx-calendar"></i> {date}
                    </span>
                  </div>

                  <div className="ct-body">
                    <h3 className="ct-name" title={title}>
                      {title}
                    </h3>
                    <div className="ct-actions">
                      <a
                        href={cleanUrl}
                        className="ct-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="View"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <i className="bx bx-show"></i> View
                      </a>
                      <button
                        className="ct-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDownload(cleanUrl, cert.title);
                        }}
                        type="button"
                        title="Download"
                      >
                        <i className="bx bx-download"></i> Download
                      </button>
                      {isOwnCompany && (
                        <button
                          className="ct-btn danger"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteClick(cert);
                          }}
                          type="button"
                          title="Delete"
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </motion.article>
              );
            })}
          </div>
        ) : (
          <div className="ct-empty">
            <i className="bx bx-certification"></i>
            <p>No certificates available.</p>
          </div>
        )}
      </motion.div>

      <ConfirmModal
        isOpen={!!selectedDoc}
        message={`Are you sure you want to delete "${selectedDoc?.title || selectedDoc?.file_name || "this certificate"}"?`}
        onCancel={() => setSelectedDoc(null)}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default Certificates;
